import axios from 'axios';

export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const opts = { withCredentials: true };
export const api = {
  get: (p) => axios.get(`${API_URL}/api/ae-briefs${p}`, opts).then((r) => r.data),
  post: (p, body = {}) => axios.post(`${API_URL}/api/ae-briefs${p}`, body, opts).then((r) => r.data),
  patch: (p, body) => axios.patch(`${API_URL}/api/ae-briefs${p}`, body, opts).then((r) => r.data),
  del: (p) => axios.delete(`${API_URL}/api/ae-briefs${p}`, opts).then((r) => r.data),
};

export const AE_ROLES = ['admin', 'manager', 'account_executive'];
export const DELIVERABLES = ['Reel', 'Story', 'Reel + Story', 'UGC', 'YT Integration', 'YT Dedicated', 'Multi-platform'];
export const TIERS = ['LUXE', 'PREMIUM', 'GOOD', 'MASSY'];
export const STATUSES = ['Active', 'Paused', 'Closed'];
export const STATUS_STYLE = {
  Active: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  Paused: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  Closed: 'bg-zinc-500/10 text-zinc-500 dark:text-zinc-400',
};
export const LABEL = 'text-xs font-semibold uppercase tracking-[0.08em] block mb-2 text-[#0F0F0F] dark:text-white';
export const FIELD = 'w-full h-9 rounded-md px-3 text-sm bg-white dark:bg-[#1A1D24] border border-black/[0.12] dark:border-white/[0.08] text-[#0F0F0F] dark:text-white placeholder-[#A1A1AA] dark:placeholder-zinc-500 focus:outline-none focus:border-[#FF451A]/60';
export const BTN = 'rounded-full px-4 py-2 text-xs font-medium inline-flex items-center gap-1.5 border border-black/[0.12] dark:border-white/[0.08] bg-white dark:bg-[#1A1D24] text-[#0F0F0F] dark:text-white hover:border-[#FF451A]/40 disabled:opacity-40 transition-colors';
export const BTN_PRIMARY = 'rounded-full px-4 py-2 text-xs font-semibold inline-flex items-center gap-1.5 bg-[#FF451A] hover:bg-[#E63E17] text-white disabled:opacity-40 transition-colors';

export const inr = (n) => (n || n === 0 ? `₹${Number(n).toLocaleString('en-IN')}` : '—');
export const budgetText = (b) => (b.budget_min || b.budget_max ? `${inr(b.budget_min)} – ${inr(b.budget_max)}` : 'Open');
export const dateText = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');
export const errMsg = (e, fallback) => {
  const d = e.response?.data?.detail;
  return typeof d === 'string' ? d : fallback;
};

// Brief -> existing Brief Suggestions form state.
const TYPE = { Reel: 'Non-collab Reel', 'YT Integration': 'YouTube Integration', 'YT Dedicated': 'YouTube Integration' };
export const briefToForm = (b, empty) => ({
  ...empty,
  brand_name: b.brand_name,
  campaign_type: TYPE[b.deliverable] || b.deliverable,
  categories: b.niche || [],
  city: b.city || [],
  state: b.state || [],
  quality_tiers: b.quality_tier || [],
  min_followers: b.followers_min ?? '',
  max_followers: b.followers_max ?? '',
  budget_per_creator: b.budget_max ?? '',
});
